<template>
  <div class="log-in-top">
    <div class="logo-big">
      <ZubmillLogoIcon />
    </div>
    <h1 class="h2">{{ text }}</h1>
    <slot />
  </div>
</template>

<script>
  import ZubmillLogoIcon from '@/icons/zubmill-logo.svg';

  export default {
    name: 'Welcome',
    components: {
      ZubmillLogoIcon,
    },
    props: {
      text: String,
    },
  };
</script>
